import { PhoneNumberFormat } from './enums';
import { Helper } from './helper';
import { PhoneNumberFormatter } from './phone-number-formatter';

export class Office {

  address1: string = '';
  address2: string;
  city: string = '';
  civicActivities: string[];
  country: string = '';
  email: string;
  fax: number;
  languages: string[];
  latitude: number;
  legacyRemaxId: string; // TODO: ????
  location: string;
  longDistance: any; // TODO: ????
  longitude: number;
  managerRemaxAgentId: number; // TODO: ????
  officeName: string;
  ownerRemaxAgentId: number; // TODO: ????
  personifyId: number;
  postalCode: string;
  propertyTypes: string[];
  relationships: [{
    relationshipPersonifyId: number | string
    relationshipType: string // OWNER, MAIN CONTACT, MULTIMAIN, MANAGER, ASSOCIATE, STAFF,
  }];
  sourceSystemId: string;
  sourceSystem: string; // HMS or iFranchise. Used in lead creation.
  serviceAreas: string[];
  specialties: string[];
  state: string = '';
  telephone: string;
  tollFreeOffice: number;
  website: string;
  detailUrl: string; //  link to office profile page already formatted

  fullAddress: string;
  parsedPhoneNumber?: string;
  hasSocialMedia?: boolean;
  showComingSoonButton: boolean;

  jsonLdSchema: object[] = [];


  getAgentRelationshipType(agentPersonifyId: string): string {
    if (this.relationships && this.relationships.length) {
      const match = this.relationships.find((r) => r.relationshipPersonifyId === agentPersonifyId);
      if (match) return match.relationshipType;
    }
    return null;
  }

  constructor(officeStub?: any) {
    if (officeStub) {
      Object.keys(officeStub).forEach((key) => {
        this[key] = officeStub[key];
      });

      this.fullAddress = [this.address1 + (this.address2 ? ' ' + this.address2 : ''), this.city + ' ' + this.state + ' ' + this.postalCode + ' ' + this.country].join(', ');
      this.parsedPhoneNumber = this.telephone
        ? PhoneNumberFormatter.format(this.telephone, PhoneNumberFormat.CA_NATIONAL)
        : '';
      this.hasSocialMedia = this.website && this.website.length > 0;

      // TODO: dont need this after they update their code to remove domains
      const officeProfileUrlRegex = /https?:\/\/www\.remax\.ca/g;
      this.detailUrl = this.detailUrl ? Helper.prependIndividualPrefix('/', this.detailUrl.replace(officeProfileUrlRegex, '')) : '';

      this.website = this.website && this.website.indexOf('://') > 0 ? this.website : 'http://' + this.website;

      this.jsonLdSchema = [{
        '@context': 'http://schema.org',
        '@graph': [
          {
            '@type': 'LocalBusiness',
            address: {
              '@type': 'PostalAddress',
              streetAddress: this.fullAddress,
              addressLocality: this.city,
              addressRegion: this.state,
              postalCode: this.postalCode
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: this.latitude,
              longitude: this.longitude
            },
            name: this.officeName,
            image: '',
            telephone: this.parsedPhoneNumber
          },
        ]
      }];
    }
  }

  static trackBy(index, office: Office) {
    return office.personifyId;
  }
}

